import { BrowserHistory, Update } from 'history';
import React, { useState, useLayoutEffect, ReactElement } from 'react';
import { Router } from 'react-router-dom';

interface IProps {
    basename: string;
    children: ReactElement;
    history: BrowserHistory;
}

const RouterProvider: React.FC<IProps> = ({
    basename,
    children,
    history,
}: IProps) => {
    const [state, setState] = useState<Update>({
        action: history.action,
        location: history.location,
    });

    useLayoutEffect(
        () =>
            history.listen((args) => {
                setState(args);
            }),
        [history],
    );

    return (
        <>
            <Router
                basename={basename}
                children={children}
                location={state.location}
                navigationType={state.action}
                navigator={history}
            />
        </>
    );
};

export default RouterProvider;
